import { useEffect, useState } from "react";
import { DropdownOption, getSortedCollection } from "sprint-common-web";

import { useVideoRekognitionResultContext } from "../hooks/useVideoRekognitionResultContext";
import { RekognitionResultItem } from "./RekognitionResultItem";
import { RekognitionResultListingFilters } from "./useRekognitionResultListingFilters";

export const useRekognitionResultListing = (filters: RekognitionResultListingFilters) => {
    const [items, setItems] = useState<RekognitionResultItem[]>([]);
    const { items: rekognitionItems, selectedItems, isLoading, setSelectedItems } = useVideoRekognitionResultContext();

    useEffect(() => {
        saveData();
    }, [filters, rekognitionItems.length]);

    const saveData = (): void => {
        const sortedAndFilteredItems = getSortedAndFilteredItems();

        setItems(sortedAndFilteredItems);
    };

    const typeOptions = getTypeOptions(rekognitionItems);

    const getSortedAndFilteredItems = () => {
        const sortedItems = getSortedCollection(rekognitionItems, filters.sortBy, filters.sortOrder);

        return filterItems(
            sortedItems,
            filters.typeIds?.length ? filters.typeIds : typeOptions.map((option) => option.key)
        );
    };

    return {
        items,
        isLoading,
        filters,
        typeOptions,
        saveData,
        selectedItems,
        setSelectedItems
    };
};

const filterItems = (items: RekognitionResultItem[], typeIds: string[]) =>
    items.filter((item) => typeIds.includes(item.type));

const getTypeOptions = (items: RekognitionResultItem[]): DropdownOption[] => {
    const filteredTypes = new Set(items.map((item) => item.type));

    return Array.from(filteredTypes).map((item) => {
        return { key: item, text: item };
    });
};
